import { SkeletonContentDetail as ContentDetail } from './SkeletonContentDetail'
import { SkeletonContentDetailDesktop as ContentDetailDesktop } from './SkeletonContentDetailDesktop'
import { SkeletonHome as Home } from './SkeletonHome'
import { SkeletonResumedChart as ResumedChart } from './SkeletonResumedChart'

export default { ResumedChart, ContentDetail, ContentDetailDesktop, Home }
